module.exports = __webpack_public_path__ + "img/1494642047.32e3b981.jpg";